import { render, staticRenderFns } from "./CvView.vue?vue&type=template&id=1dd15244&"
import script from "./CvView.vue?vue&type=script&lang=js&"
export * from "./CvView.vue?vue&type=script&lang=js&"
import style0 from "./CvView.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports